import App from "./components/App";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import ReactDOM from "react-dom";

import React from 'react';
import {initReactI18next} from "react-i18next";
import detector from "i18next-browser-languagedetector";
import i18next from "i18next";

import de from "./translations/de.json";

// configure localization
i18next
.use(new detector(null, {order: ['navigator']}))
.use(initReactI18next)
.init({
  defaultNS: 'common',
  keySeparator: false,
  resources: {
    de: {
        common: de
    }
  },
  parseMissingKeyHandler: (key : string, dflt? : string) => {
    const en_string = dflt ?? key;
    const default_is_key = (en_string === key)

    if (i18next.language !== 'en')
      console.error(`Missing ${i18next.language} translation for${default_is_key ? '' : (' key "' + key + '"')}: ${en_string}`)
    
    return en_string;
  }
});

ReactDOM.render(<App />, document.getElementById("root"));
